module.exports = __webpack_public_path__ + "static/8gde-40bdfdb2b033e671d8dc1afae571ef94.gif";